<div (click)="closeCoinSelector()">
  <app-generic-swap
    [isGroup]="true"
    [srcCoinSelectorOpened]="srcCoinSelectorOpened"
    [destCoinSelectorOpened]="destCoinSelectorOpened"
    [availableCoins]="coins"
    [cryptoBalances]="cryptoBalances"
    [coinClicked]="coinClicked"
    (openSelectSrcCoin)="srcCoinSelectorOpened = $event"
    (openSelectDestCoin)="destCoinSelectorOpened = $event"
  ></app-generic-swap>
</div>
